export type UtilisationStatusType = 'widget' | 'block' | 'field';
